import { createApp, toRaw } from 'vue';
import axios from 'axios';
import { Loader } from '@googlemaps/js-api-loader';
import { PostcodeLookup } from "@ideal-postcodes/postcode-lookup";
import Swiper, {Navigation, Thumbs} from "swiper";

var params = new URL(location.href).searchParams;
var bikeOptions = {
  'categoryIds': [],
  'q': '',
  'pageSize': '10',
  'priceBand': '\"all\"',
  'sortBy': 'postDate desc',
  'sortLabel': 'newest',
  'pageNum': '1',
  'brandIds': [],
  // 'modelIds': [],
  'yearIds': [],
  'condition': 'all',
  'onlyOffers': false
};
var merchOptions = {
  'categoryIds': [],
  'presetCategory': [],
  'q': '',
  'pageSize': '10',
  'priceBand': '\"all\"',
  'sortBy': 'postDate desc',
  'sortLabel': 'newest',
  'pageNum': '1',
  'brandIds': [],
};
var partsAccessoriesOptions = {
    'categoryIds': [],
    'presetCategory': [],
    'q': '',
    'pageSize': '10',
    'priceBand': '\"all\"',
    'sortBy': 'postDate desc',
    'sortLabel': 'newest',
    'pageNum': '1',
    'brandIds': [],
    // 'modelIds': [],
};
var categoryOptions = {
    'categoryIds': [],
    'presetCategory': [],
    'presetProductType': [],
    'presetProductCategoryGroup': [],
    'q': '',
    'pageSize': '10',
    'priceBand': '\"all\"',
    'sortBy': 'postDate desc',
    'sortLabel': 'newest',
    'pageNum': '1',
    'brandIds': [],
    'casualClothingIds': [],
    'ridingGearIds': [],
    'accessoriesAndGiftIds': [],
    'partsRoadOffroadIds': [],
    'partsIds': [],
    'justTrialIds': [],
    // 'modelIds': [],
};
var productSearchOptions = {
    'categoryIds': [],
    'search': '',
    'pageSize': '10',
    'priceBand': '\"all\"',
    'sortBy': 'score',
    'sortLabel': 'relevance',
    'pageNum': '1',
    'brandIds': [],
    // 'modelIds': [],
};
var newsOptions = {
  'categoryIds': [],
  'q': '',
  'pageSize': '8',
  'sortBy': 'postDate desc',
  'sortLabel': 'newest',
  'pageNum': '1',
  'brandIds': []
}
if (params.getAll('categoryIds[]')) {
    bikeOptions.categoryIds = params.getAll('categoryIds[]');
    merchOptions.categoryIds = params.getAll('categoryIds[]');
    partsAccessoriesOptions.categoryIds = params.getAll('categoryIds[]');
    categoryOptions.categoryIds = params.getAll('categoryIds[]');
    productSearchOptions.categoryIds = params.getAll('categoryIds[]');
}
if (params.getAll('brandIds[]')) {
    bikeOptions.brandIds = params.getAll('brandIds[]');
    merchOptions.brandIds = params.getAll('brandIds[]');
    partsAccessoriesOptions.brandIds = params.getAll('brandIds[]');
    categoryOptions.brandIds = params.getAll('brandIds[]');
    productSearchOptions.brandIds = params.getAll('brandIds[]');
    newsOptions.brandIds = params.getAll('brandIds[]');
}
if (params.getAll('casualClothingIds[]')) {
    categoryOptions.casualClothingIds = params.getAll('casualClothingIds[]');
}
if (params.getAll('ridingGearIds[]')) {
    categoryOptions.ridingGearIds = params.getAll('ridingGearIds[]');
}
if (params.getAll('accessoriesAndGiftIds[]')) {
    categoryOptions.accessoriesAndGiftIds = params.getAll('accessoriesAndGiftIds[]');
}
if (params.getAll('partsRoadOffroadIds[]')) {
    categoryOptions.partsRoadOffroadIds = params.getAll('partsRoadOffroadIds[]');
}
if (params.getAll('partsIds[]')) {
    categoryOptions.partsIds = params.getAll('partsIds[]');
}
if (params.getAll('justTrialIds[]')) {
    categoryOptions.justTrialIds = params.getAll('justTrialIds[]');
}
if (params.get('clearance')) {
    categoryOptions.clearance = params.get('clearance') === 'true';
}
// if (params.getAll('modelIds[]')) {
//     bikeOptions.modelIds = params.getAll('modelIds[]');
//     partsAccessoriesOptions.modelIds = params.getAll('modelIds[]');
//     categoryOptions.modelIds = params.getAll('modelIds[]');
//     productSearchOptions.modelIds = params.getAll('modelIds[]');
// }
if (params.getAll('yearIds[]')) {
    bikeOptions.yearIds = params.getAll('yearIds[]');
}
if (params.get('priceBand')) {
    bikeOptions.priceBand = params.get('priceBand');
    merchOptions.priceBand = params.get('priceBand');
    partsAccessoriesOptions.priceBand = params.get('priceBand');
    categoryOptions.priceBand = params.get('priceBand');
    productSearchOptions.priceBand = params.get('priceBand');
}
if (params.get('sortBy')) {
    bikeOptions.sortBy = params.get('sortBy');
    merchOptions.sortBy = params.get('sortBy');
    partsAccessoriesOptions.sortBy = params.get('sortBy');
    categoryOptions.sortBy = params.get('sortBy');
    productSearchOptions.sortBy = params.get('sortBy');
}
if (params.get('condition')) {
    bikeOptions.condition = params.get('condition');
}
if (params.get('search')) {
    productSearchOptions.search = params.get('search');
}
if (document.querySelector('#preset-brand')) {
    bikeOptions.brandIds.push(document.querySelector("#preset-brand").innerText);
    merchOptions.brandIds.push(document.querySelector("#preset-brand").innerText);
    partsAccessoriesOptions.brandIds.push(document.querySelector("#preset-brand").innerText);
    categoryOptions.brandIds.push(document.querySelector("#preset-brand").innerText);
    productSearchOptions.brandIds.push(document.querySelector("#preset-brand").innerText);
    newsOptions.brandIds.push(document.querySelector("#preset-brand").innerText);
}
if (document.querySelector('#preset-bikeType')) {
    bikeOptions.categoryIds.push(document.querySelector("#preset-bikeType").innerText);
}
if (document.querySelector('#preset-merchType')) {
    merchOptions.presetCategory.push(document.querySelector("#preset-merchType").innerText);
}
if (document.querySelector('#preset-partsAccessoriesType')) {
    partsAccessoriesOptions.presetCategory.push(document.querySelector("#preset-partsAccessoriesType").innerText);
}
if (document.querySelector('#preset-categoryType')) {
    categoryOptions.presetCategory.push(document.querySelector("#preset-categoryType").innerText);
}
if (document.querySelector('#preset-productType')) {
    categoryOptions.presetProductType.push(document.querySelector("#preset-productType").innerText);
}
if (document.querySelector('#preset-productCategoryGroup')) {
    categoryOptions.presetProductCategoryGroup.push(document.querySelector("#preset-productCategoryGroup").innerText);
}
if (document.querySelector('#preset-productSearchType')) {
    productSearchOptions.categoryIds.push(document.querySelector("#preset-productSearchType").innerText);
}
if (document.querySelector('#preset-condition')) {
    bikeOptions.condition = document.querySelector("#preset-condition").innerText;
}
if (document.querySelector('#preset-offersOnly')) {
    bikeOptions.offersOnly = document.querySelector("#preset-offersOnly").innerText;
}
if (document.querySelector('#preset-newsCategory')) {
    newsOptions.categoryIds.push(document.querySelector("#preset-newsCategory").innerText);
}

function buildGaProduct(elem) {
    let item_sku = '';
    let item_title = '';
    let item_type = '';
    let item_price = '';
    let item_qty = '1';
    if (elem) {
        item_sku = elem.dataset.gasku;
        item_title = elem.dataset.gatitle;
        item_type = elem.dataset.gatype;
        item_price = elem.dataset.gaprice;
    }
    if (document.querySelector('#quantity-0')) {
        item_qty = document.querySelector('#quantity-0').value;
    }
    return {
        'sku': item_sku,
        'title': item_title,
        'type_name': item_type,
        'salePrice': item_price.replaceAll('£', ''),
        'qty': item_qty
    };
}

function dataLayerAddToCart(product) {
    let dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
            items: [
                {
                    'item_id': product.sku,
                    'item_name': product.title,
                    'item_category': product.type_name,
                    'price': product.salePrice,
                    'quantity': product.qty
                }
            ]
        }
    });
    window.dataLayer = dataLayer;
}

const bikesApp = createApp({
  delimiters: ['{*', '*}'],
  // initial data
  data() {
    return {
      options: bikeOptions,
      bikes: {},
      request: null,
      bikesError: false
    }
  },
  methods: {
    callEndpoint() {
      var submission = new FormData();
      submission.append('action', 'productsfilter/products-filter/bikes');
      submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);
      
      for (var key in this.options) {
        if (Array.isArray(this.options[key])) {
          this.options[key].forEach(function(item, index) {
            submission.append(key + "[]", item);
          });
        } else if (this.options[key]) {
          submission.append(key, this.options[key]);
        }
      }
      return submission;
    },
    cleanTitle(title, shortTitle) {
      if (title.includes(shortTitle)) {
        return title.replace(shortTitle, '');
      }
      return title;
    },
    reloadBikes() {
      var loading = true;
      this.options['pageNum'] = 1;
      if (document.querySelector("#bikeQueryInput")) {
        this.options['q'] = document.querySelector("#bikeQueryInput").value;
      }
      this.bikes = {};
      this.bikesError = false;
      
      if (this.request) {
        this.request.cancel();
        this.request = null;
      }
      
      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
      
      var submission = this.callEndpoint();
      axios.post('', submission, {cancelToken:axiosSource.token}).then(function (response) {
        this.request = null;
        var responseData = false;
        if (response.data.bikes) {
          this.bikes = response.data.bikes;
          responseData = response.data;
          this.bikesError = false;
        } else if (response.bikes) {
          this.bikes = response.bikes;
          responseData = response;
          this.bikesError = false;
        } else if (response.data.error) {
          this.bikes = {};
          this.bikesError = response.data.error;
        } else if (response.error) {
          this.bikes = {};
          this.bikesError = response.error;
        }
        loading = false;
        
        if (!this.bikesError) {
          if (responseData.pagination.currentPage < responseData.pagination.totalPages) {
            this.options['pageNum'] = responseData.pagination.currentPage + 1;
            this.nextPage();
          } else {
            this.options['pageNum'] = 1;
          }
          if (responseData.pagination.currentPage == responseData.pagination.totalPages) {
              this.bikesError = "No more bikes";
          }
          if (responseData.pagination.totalResults == 0 || responseData.pagination.totalResults == '0') {
              this.bikesError = "Sorry, no matching bikes were found. You can use our search or change your filters to find what you're looking for.";
          }
          if (lazyLoad) {
              lazyLoad.getErrors('bikes');
          }
        }
      }.bind(this)).catch(function (error) {
        console.log(error);
        loading = false;
      });
    },
    nextPage() {
      if (this.options['pageNum'] == 1) {
        return false;
      }
      var loading = true;
      this.bikesError = false;
      
      if (this.request) {
          this.request.cancel();
          this.request = null;
      }
      
      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
      
      var submission = this.callEndpoint();
      axios.post('', submission, { cancelToken:axiosSource.token }).then(function (response) {
          this.request = null;
          var responseData = false;
          if (response.data.bikes) {
              responseData = response.data;
              this.bikesError = false;
          } else if (response.bikes) {
              responseData = response;
              this.bikesError = false;
          } else if (response.data.error) {
              this.bikesError = response.data.error;
          } else if (response.error) {
              this.bikesError = response.error;
          }
          loading = false;
          if (!this.bikesError) {
              var fullBikes = this.bikes;
              responseData.bikes.forEach(function(bike, index) {
                  fullBikes.push(bike);
              });
              this.bikes = fullBikes;
              if (responseData.pagination.currentPage < responseData.pagination.totalPages) {
                  this.options['pageNum'] = responseData.pagination.currentPage + 1;
                  this.nextPage();
              } else {
                  this.options['pageNum'] = 1;
              }
              if (responseData.pagination.currentPage == responseData.pagination.totalPages) {
                  this.bikesError = "No more bikes";
              }
              if (responseData.pagination.totalResults == 0 || responseData.pagination.totalResults == '0') {
                  this.bikesError = "Sorry, no matching bikes were found. You can use our search or change your filters to find what you're looking for.";
              }
              if (lazyLoad) {
                  lazyLoad.getErrors('bikes');
              }
          }
      }.bind(this)).catch(function (error) {
          console.log(error);
          loading = false;
      });
    }
  },
  mounted() {
      if (document.querySelector('#bikesContainer')) {
        this.reloadBikes();
      }
  }
});
const bikes = bikesApp.mount('#bikesContainer');

const bikeFiltersApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            options: bikeOptions,
        }
    },
    methods: {
        reloadUrl() {
            var url = document.querySelector('#bikesContainer').dataset.pageurl+'?';
            for (var key in this.options) {
                if (key != 'pageNum') {
                    if (Array.isArray(this.options[key])) {
                        this.options[key].forEach(function(item, index) {
                            url += key + '[]=' + encodeURIComponent(item) + '&';
                        });
                    } else if (this.options[key]) {
                        url += key + '=' + encodeURIComponent(this.options[key]) + '&';
                    }
                }
            }
            window.history.replaceState({}, null, url.slice(0,-1));
        },
        clearOptions(key) {
            if (Array.isArray(this.options[key])) {
                this.options[key] = [];
            } else {
                this.options[key] = '';
            }
        },
        updateOptions(event, key, value) {
            this.options['pageNum'] = 1;
            if (Array.isArray(this.options[key])) {
                if (this.options[key].includes(value)) {
                    this.options[key] = this.options[key].filter(function(filterValue, index, arr){
                        return filterValue != value;
                    });
                } else {
                    this.options[key].push(value);
                }
            } else {
                this.options[key] = value;
            }

            this.reloadUrl();
            bikes.reloadBikes();
        },
        toggleAccordion(expandId, event) {
          var accordion = document.querySelector("#" + expandId);
           
           accordion.classList.toggle("max-h-0");
           accordion.classList.toggle("max-h-80");
           accordion.classList.toggle("overflow-hidden");
           accordion.classList.toggle("overflow-auto");
           event.target.closest(".accordion-header").querySelector(".icon-chevron-down").classList.toggle("rotate-180");
        }
    },
});
const bikeFilters = bikeFiltersApp.mount('#bikeFilters');

const merchApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            options: merchOptions,
            merch: {},
            request: null,
            merchError: false
        }
    },
    methods: {
        callEndpoint() {
            var submission = new FormData();
            submission.append('action', 'productsfilter/products-filter/merch');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);

            for (var key in this.options) {
                if (Array.isArray(this.options[key])) {
                    this.options[key].forEach(function(item, index) {
                        submission.append(key + "[]", item);
                    });
                } else if (this.options[key]) {
                    submission.append(key, this.options[key]);
                }
            }
            return submission;
        },
        reloadMerch() {
            var loading = true;
            this.options['pageNum'] = 1;
            if (document.querySelector("#merchQueryInput")) {
                this.options['q'] = document.querySelector("#merchQueryInput").value;
            }
            this.merch = {};
            this.merchError = false;

            if (this.request) {
                this.request.cancel();
                this.request = null;
            }

            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

            var submission = this.callEndpoint();
            axios.post('', submission, {cancelToken:axiosSource.token}).then(function (response) {
                this.request = null;
                var responseData = false;
                if (response.data.merch) {
                    this.merch = response.data.merch;
                    responseData = response.data;
                    this.merchError = false;
                } else if (response.merch) {
                    this.merch = response.merch;
                    responseData = response;
                    this.merchError = false;
                } else if (response.data.error) {
                    this.merch = {};
                    this.merchError = response.data.error;
                } else if (response.error) {
                    this.merch = {};
                    this.merchError = response.error;
                }
                loading = false;

                if (!this.merchError) {
                    if (responseData.pagination.currentPage < responseData.pagination.totalPages) {
                        this.options['pageNum'] = responseData.pagination.currentPage + 1;
                        this.nextPage();
                    } else {
                        this.options['pageNum'] = 1;
                    }
                    if (responseData.pagination.currentPage == responseData.pagination.totalPages) {
                        this.merchError = "No more merch";
                    }
                    if (responseData.pagination.totalResults == 0 || responseData.pagination.totalResults == '0') {
                        this.merchError = "Sorry, no matching merchandise was found. You can use our search or change your filters to find what you're looking for.";
                    }
                    if (lazyLoad) {
                        lazyLoad.getErrors('merch');
                    }
                }
            }.bind(this)).catch(function (error) {
                console.log(error);
                loading = false;
            });
        },
        nextPage() {
            if (this.options['pageNum'] == 1) {
                return false;
            }
            var loading = true;
            this.merchError = false;

            if (this.request) {
                this.request.cancel();
                this.request = null;
            }

            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

            var submission = this.callEndpoint();
            axios.post('', submission, { cancelToken:axiosSource.token }).then(function (response) {
                this.request = null;
                var responseData = false;
                if (response.data.merch) {
                    responseData = response.data;
                    this.merchError = false;
                } else if (response.merch) {
                    responseData = response;
                    this.merchError = false;
                } else if (response.data.error) {
                    this.merchError = response.data.error;
                } else if (response.error) {
                    this.merchError = response.error;
                }
                loading = false;
                if (!this.merchError) {
                    var fullMerch = this.merch;
                    responseData.merch.forEach(function(item, index) {
                        fullMerch.push(item);
                    });
                    this.merch = fullMerch;
                    if (responseData.pagination.currentPage < responseData.pagination.totalPages) {
                        this.options['pageNum'] = responseData.pagination.currentPage + 1;
                        this.nextPage();
                    } else {
                        this.options['pageNum'] = 1;
                    }
                    if (responseData.pagination.currentPage == responseData.pagination.totalPages) {
                        this.merchError = "No more merch";
                    }
                    if (responseData.pagination.totalResults == 0 || responseData.pagination.totalResults == '0') {
                        this.merchError = "Sorry, no matching merchandise was found. You can use our search or change your filters to find what you're looking for.";
                    }
                    if (lazyLoad) {
                        lazyLoad.getErrors('merch');
                    }
                }
            }.bind(this)).catch(function (error) {
                console.log(error);
                loading = false;
            });
        }
    },
    mounted() {
        if (document.querySelector('#merchContainer')) {
            this.reloadMerch();
        }
    }
});
const merch = merchApp.mount('#merchContainer');

const merchFiltersApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            options: merchOptions,
            categories: [],
            request: null
        }
    },
    methods: {
        reloadUrl() {
            var url = document.querySelector('#merchContainer').dataset.pageurl+'?';
            for (var key in this.options) {
                if (key != 'pageNum') {
                    if (Array.isArray(this.options[key])) {
                        this.options[key].forEach(function(item, index) {
                            url += key + '[]=' + encodeURIComponent(item) + '&';
                        });
                    } else if (this.options[key]) {
                        url += key + '=' + encodeURIComponent(this.options[key]) + '&';
                    }
                }
            }
            window.history.replaceState({}, null, url.slice(0,-1));
        },
        clearOptions(key) {
            if (Array.isArray(this.options[key])) {
                this.options[key] = [];
            } else {
                this.options[key] = '';
            }
        },
        reloadCategories() {
            if (this.request) {
                this.request.cancel();
                this.request = null;
            }

            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

            var submission = new FormData();
            submission.append('action', 'productsfilter/products-filter/merch-categories');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);
            this.options['brandIds'].forEach(function(item, index) {
                submission.append("brandIds[]", item);
            });

            const filterApp = this;

            axios.post('', submission, {cancelToken:axiosSource.token}).then(function (response) {
                if (response.data.categories) {
                    filterApp.categories = response.data.categories;
                } else if (response.categories) {
                    filterApp.categories = response.categories;
                } else {
                    filterApp.categories = [];
                }
            });
        },
        updateOptions(event, key, value) {
            this.options['pageNum'] = 1;
            if (Array.isArray(this.options[key])) {
                if (this.options[key].includes(value)) {
                    this.options[key] = this.options[key].filter(function(filterValue, index, arr){
                        return filterValue != value;
                    });
                } else {
                    this.options[key].push(value);
                }
            } else {
                this.options[key] = value;
            }

            this.reloadUrl();

            if (key == 'brandIds') {
                // this.reloadCategories();
            }

            merch.reloadMerch();
        },
        toggleAccordion(expandId, event) {
            var accordion = document.querySelector("#" + expandId);

            accordion.classList.toggle("max-h-0");
            accordion.classList.toggle("max-h-80");
            accordion.classList.toggle("overflow-hidden");
            accordion.classList.toggle("overflow-auto");
            event.target.closest(".accordion-header").querySelector(".icon-chevron-down").classList.toggle("rotate-180");
        }
    },
    mounted() {
        this.reloadCategories();
    }
});
const merchFilters = merchFiltersApp.mount('#merchFilters');

const partsAccessoriesApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            options: partsAccessoriesOptions,
            partsAccessories: {},
            request: null,
            partsAccessoriesError: false
        }
    },
    methods: {
        callEndpoint() {
            var submission = new FormData();
            submission.append('action', 'productsfilter/products-filter/parts-accessories');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);

            for (var key in this.options) {
                if (Array.isArray(this.options[key])) {
                    this.options[key].forEach(function(item, index) {
                        submission.append(key + "[]", item);
                    });
                } else if (this.options[key]) {
                    submission.append(key, this.options[key]);
                }
            }
            return submission;
        },
        reloadPartsAccessories() {
            var loading = true;
            this.options['pageNum'] = 1;
            if (document.querySelector("#partsAccessoriesQueryInput")) {
                this.options['q'] = document.querySelector("#partsAccessoriesQueryInput").value;
            }
            this.partsAccessories = {};
            this.partsAccessoriesError = false;

            if (this.request) {
                this.request.cancel();
                this.request = null;
            }

            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

            var submission = this.callEndpoint();
            axios.post('', submission, {cancelToken:axiosSource.token}).then(function (response) {
                this.request = null;
                var responseData = false;
                if (response.data.partsAccessories) {
                    this.partsAccessories = response.data.partsAccessories;
                    responseData = response.data;
                    this.partsAccessoriesError = false;
                } else if (response.partsAccessories) {
                    this.partsAccessories = response.partsAccessories;
                    responseData = response;
                    this.partsAccessoriesError = false;
                } else if (response.data.error) {
                    this.partsAccessories = {};
                    this.partsAccessoriesError = response.data.error;
                } else if (response.error) {
                    this.partsAccessories = {};
                    this.partsAccessoriesError = response.error;
                }
                loading = false;

                if (!this.partsAccessoriesError) {
                    if (responseData.pagination.currentPage < responseData.pagination.totalPages) {
                        this.options['pageNum'] = responseData.pagination.currentPage + 1;
                        this.nextPage();
                    } else {
                        this.options['pageNum'] = 1;
                    }
                    if (responseData.pagination.currentPage == responseData.pagination.totalPages) {
                        this.partsAccessoriesError = "No more parts & accessories";
                    }
                    if (responseData.pagination.totalResults == 0 || responseData.pagination.totalResults == '0') {
                        this.partsAccessoriesError = "Sorry, no matching parts & accessories were found. You can use our search or change your filters to find what you're looking for.";
                    }
                    if (lazyLoad) {
                        lazyLoad.getErrors('partsAccessories');
                    }
                }
            }.bind(this)).catch(function (error) {
                console.log(error);
                loading = false;
            });
        },
        nextPage() {
            if (this.options['pageNum'] == 1) {
                return false;
            }
            var loading = true;
            this.partsAccessoriesError = false;

            if (this.request) {
                this.request.cancel();
                this.request = null;
            }

            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

            var submission = this.callEndpoint();
            axios.post('', submission, { cancelToken:axiosSource.token }).then(function (response) {
                this.request = null;
                var responseData = false;
                if (response.data.partsAccessories) {
                    responseData = response.data;
                    this.partsAccessoriesError = false;
                } else if (response.partsAccessories) {
                    responseData = response;
                    this.partsAccessoriesError = false;
                } else if (response.data.error) {
                    this.partsAccessoriesError = response.data.error;
                } else if (response.error) {
                    this.partsAccessoriesError = response.error;
                }
                loading = false;
                if (!this.partsAccessoriesError) {
                    var fullPartsAccessories = this.partsAccessories;
                    responseData.partsAccessories.forEach(function(item, index) {
                        fullPartsAccessories.push(item);
                    });
                    this.partsAccessories = fullPartsAccessories;
                    if (responseData.pagination.currentPage < responseData.pagination.totalPages) {
                        this.options['pageNum'] = responseData.pagination.currentPage + 1;
                        this.nextPage();
                    } else {
                        this.options['pageNum'] = 1;
                    }
                    if (responseData.pagination.currentPage == responseData.pagination.totalPages) {
                        this.partsAccessoriesError = "No more parts & accessories";
                    }
                    if (responseData.pagination.totalResults == 0 || responseData.pagination.totalResults == '0') {
                        this.partsAccessoriesError = "Sorry, no matching parts & accessories were found. You can use our search or change your filters to find what you're looking for.";
                    }
                    if (lazyLoad) {
                        lazyLoad.getErrors('partsAccessories');
                    }
                }
            }.bind(this)).catch(function (error) {
                console.log(error);
                loading = false;
            });
        }
    },
    mounted() {
        if (document.querySelector('#partsAccessoriesContainer')) {
            this.reloadPartsAccessories();
        }
    }
});
const partsAccessories = partsAccessoriesApp.mount('#partsAccessoriesContainer');

const partsAccessoriesFiltersApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            options: partsAccessoriesOptions,
            categories: [],
            request: null
        }
    },
    methods: {
        reloadUrl() {
            var url = document.querySelector('#partsAccessoriesContainer').dataset.pageurl+'?';
            for (var key in this.options) {
                if (key != 'pageNum') {
                    if (Array.isArray(this.options[key])) {
                        this.options[key].forEach(function(item, index) {
                            url += key + '[]=' + encodeURIComponent(item) + '&';
                        });
                    } else if (this.options[key]) {
                        url += key + '=' + encodeURIComponent(this.options[key]) + '&';
                    }
                }
            }
            window.history.replaceState({}, null, url.slice(0,-1));
        },
        clearOptions(key) {
            if (Array.isArray(this.options[key])) {
                this.options[key] = [];
            } else {
                this.options[key] = '';
            }
        },
        reloadCategories() {
            if (this.request) {
                this.request.cancel();
                this.request = null;
            }

            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

            var submission = new FormData();
            submission.append('action', 'productsfilter/products-filter/parts-categories');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);
            this.options['brandIds'].forEach(function(item, index) {
                submission.append("brandIds[]", item);
            });

            const filterApp = this;

            axios.post('', submission, {cancelToken:axiosSource.token}).then(function (response) {
                if (response.data.categories) {
                    filterApp.categories = response.data.categories;
                } else if (response.categories) {
                    filterApp.categories = response.categories;
                } else {
                    filterApp.categories = [];
                }
            });
        },
        updateOptions(event, key, value) {
            this.options['pageNum'] = 1;
            if (Array.isArray(this.options[key])) {
                if (this.options[key].includes(value)) {
                    this.options[key] = this.options[key].filter(function(filterValue, index, arr){
                        return filterValue != value;
                    });
                } else {
                    this.options[key].push(value);
                }
            } else {
                this.options[key] = value;
            }

            this.reloadUrl();

            if (key == 'brandIds') {
                // this.reloadCategories();
            }

            partsAccessories.reloadPartsAccessories();
        },
        toggleAccordion(expandId, event) {
            var accordion = document.querySelector("#" + expandId);

            accordion.classList.toggle("max-h-0");
            accordion.classList.toggle("max-h-80");
            accordion.classList.toggle("overflow-hidden");
            accordion.classList.toggle("overflow-auto");
            event.target.closest(".accordion-header").querySelector(".icon-chevron-down").classList.toggle("rotate-180");
        }
    },
    mounted() {
        this.reloadCategories();
    }
});
const partsAccessoriesFilters = partsAccessoriesFiltersApp.mount('#partsAccessoriesFilters');

const categoryApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            options: categoryOptions,
            category: {},
            request: null,
            categoryError: false
        }
    },
    methods: {
        callEndpoint() {
            var submission = new FormData();
            submission.append('action', 'productsfilter/products-filter/category');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);

            for (var key in this.options) {
                if (Array.isArray(this.options[key])) {
                    this.options[key].forEach(function(item, index) {
                        submission.append(key + "[]", item);
                    });
                } else if (this.options[key]) {
                    submission.append(key, this.options[key]);
                }
            }
            return submission;
        },
        reloadCategory() {
            var loading = true;
            this.options['pageNum'] = 1;
            if (document.querySelector("#categoryQueryInput")) {
                this.options['q'] = document.querySelector("#categoryQueryInput").value;
            }
            this.category = {};
            this.categoryError = false;

            if (this.request) {
                this.request.cancel();
                this.request = null;
            }

            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

            var submission = this.callEndpoint();
            axios.post('', submission, {cancelToken:axiosSource.token}).then(function (response) {
                this.request = null;
                var responseData = false;
                if (response.data.category) {
                    this.category = response.data.category;
                    responseData = response.data;
                    this.categoryError = false;
                } else if (response.category) {
                    this.category = response.category;
                    responseData = response;
                    this.categoryError = false;
                } else if (response.data.error) {
                    this.category = {};
                    this.categoryError = response.data.error;
                } else if (response.error) {
                    this.category = {};
                    this.categoryError = response.error;
                }
                loading = false;

                if (!this.categoryError) {
                    if (responseData.pagination.currentPage < responseData.pagination.totalPages) {
                        this.options['pageNum'] = responseData.pagination.currentPage + 1;
                        this.nextPage();
                    } else {
                        this.options['pageNum'] = 1;
                    }
                    if (responseData.pagination.currentPage == responseData.pagination.totalPages) {
                        this.categoryError = "No more products";
                    }
                    if (responseData.pagination.totalResults == 0 || responseData.pagination.totalResults == '0') {
                        this.categoryError = "Sorry, no matching products were found. You can use our search or change your filters to find what you're looking for.";
                    }
                    if (lazyLoad) {
                        lazyLoad.getErrors('category');
                    }
                }
            }.bind(this)).catch(function (error) {
                console.log(error);
                loading = false;
            });
        },
        percentDiscount(item) {
            if (item.intSalePrice && item.intPrice && item.intSalePrice !== item.intPrice) {
                return (Math.round((1 - item.intSalePrice / item.intPrice) * 100)) + '%'
            } else {
                return '';
            }
        },
        cleanTitle(title, shortTitle) {
            if (title.includes(shortTitle)) {
                return title.replace(shortTitle, '');
            }
            return title;
        },
        nextPage() {
            if (this.options['pageNum'] == 1) {
                return false;
            }
            var loading = true;
            this.categoryError = false;

            if (this.request) {
                this.request.cancel();
                this.request = null;
            }

            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

            var submission = this.callEndpoint();
            axios.post('', submission, { cancelToken:axiosSource.token }).then(function (response) {
                this.request = null;
                var responseData = false;
                if (response.data.category) {
                    responseData = response.data;
                    this.categoryError = false;
                } else if (response.category) {
                    responseData = response;
                    this.categoryError = false;
                } else if (response.data.error) {
                    this.categoryError = response.data.error;
                } else if (response.error) {
                    this.categoryError = response.error;
                }
                loading = false;
                if (!this.categoryError) {
                    var fullCategory = this.category;
                    responseData.category.forEach(function(item, index) {
                        fullCategory.push(item);
                    });
                    this.category = fullCategory;
                    if (responseData.pagination.currentPage < responseData.pagination.totalPages) {
                        this.options['pageNum'] = responseData.pagination.currentPage + 1;
                        this.nextPage();
                    } else {
                        this.options['pageNum'] = 1;
                    }
                    if (responseData.pagination.currentPage == responseData.pagination.totalPages) {
                        this.categoryError = "No more products";
                    }
                    if (responseData.pagination.totalResults == 0 || responseData.pagination.totalResults == '0') {
                        this.categoryError = "Sorry, no matching products were found. You can use our search or change your filters to find what you're looking for.";
                    }
                    if (lazyLoad) {
                        lazyLoad.getErrors('category');
                    }
                }
            }.bind(this)).catch(function (error) {
                console.log(error);
                loading = false;
            });
        }
    },
    mounted() {
        if (document.querySelector('#categoryContainer')) {
            this.reloadCategory();
        }
    }
});
const category = categoryApp.mount('#categoryContainer');

const categoryFiltersApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            options: categoryOptions,
            categories: [],
            brands: [],
            casualClothingFilters: [],
            ridingGearFilters: [],
            accessoriesAndGiftsFilters: [],
            partsRoadOffroad: [],
            partsFilters: [],
            justTrials: [],
            request: null
        }
    },
    methods: {
        reloadUrl() {
            var url = document.querySelector('#categoryContainer').dataset.pageurl+'?';
            for (var key in this.options) {
                if (key != 'pageNum') {
                    if (Array.isArray(this.options[key])) {
                        this.options[key].forEach(function(item, index) {
                            url += key + '[]=' + encodeURIComponent(item) + '&';
                        });
                    } else if (this.options[key]) {
                        url += key + '=' + encodeURIComponent(this.options[key]) + '&';
                    }
                }
            }
            window.history.replaceState({}, null, url.slice(0,-1));
        },
        clearOptions(key) {
            if (Array.isArray(this.options[key])) {
                this.options[key] = [];
            } else {
                this.options[key] = '';
            }
        },
        reloadCategories() {
            if (this.request) {
                this.request.cancel();
                this.request = null;
            }

            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

            var submission = new FormData();
            submission.append('action', 'productsfilter/products-filter/all-categories');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);
            this.options['presetCategory'].forEach(function(item, index) {
                submission.append("presetCategory[]", item);
            });
            this.options['presetProductType'].forEach(function(item, index) {
                submission.append("presetProductType[]", item);
            });
            this.options['presetProductCategoryGroup'].forEach(function(item, index) {
                submission.append("presetProductCategoryGroup[]", item);
            });
            this.options['brandIds'].forEach(function(item, index) {
                submission.append("brandIds[]", item);
            });
            this.options['casualClothingIds'].forEach(function(item, index) {
                submission.append("casualClothingIds[]", item);
            });
            this.options['ridingGearIds'].forEach(function(item, index) {
                submission.append("ridingGearIds[]", item);
            });
            this.options['accessoriesAndGiftIds'].forEach(function(item, index) {
                submission.append("accessoriesAndGiftIds[]", item);
            });
            this.options['partsRoadOffroadIds'].forEach(function(item, index) {
                submission.append("partsRoadOffroadIds[]", item);
            });
            this.options['partsIds'].forEach(function(item, index) {
                submission.append("partsIds[]", item);
            });
            this.options['justTrialIds'].forEach(function(item, index) {
                submission.append("justTrialIds[]", item);
            });

            const filterApp = this;

            axios.post('', submission, {cancelToken:axiosSource.token}).then(function (response) {
                console.log(response.data);
                if (response.data) {
                    filterApp.brands = response.data.brands;
                    filterApp.casualClothingFilters = response.data.casualClothingFilters;
                    filterApp.ridingGearFilters = response.data.ridingGearFilters;
                    filterApp.accessoriesAndGiftsFilters = response.data.accessoriesAndGiftsFilters;
                    filterApp.partsRoadOffroad = response.data.partsRoadOffroad;
                    filterApp.partsFilters = response.data.partsFilters;
                    filterApp.justTrials = response.data.justTrials;
                } else if (response) {
                    filterApp.brands = response.brands;
                    filterApp.casualClothingFilters = response.casualClothingFilters;
                    filterApp.ridingGearFilters = response.ridingGearFilters;
                    filterApp.accessoriesAndGiftsFilters = response.accessoriesAndGiftsFilters;
                    filterApp.partsRoadOffroad = response.partsRoadOffroad;
                    filterApp.partsFilters = response.partsFilters;
                    filterApp.justTrials = response.justTrials;
                } else {
                    filterApp.brands = [];
                    filterApp.casualClothingFilters = [];
                    filterApp.ridingGearFilters = [];
                    filterApp.accessoriesAndGiftsFilters = [];
                    filterApp.partsRoadOffroad = [];
                    filterApp.partsFilters = [];
                    filterApp.justTrials = [];
                }
            });
        },
        setFilters(filters) {
            // todo this could be used to provide a list of filters, or product ids from nextPage()
            // from which the filters are build, so we only have filters with products
            console.log('setFilters', filters)
        },
        updateOptions(event, key, value) {
            this.options['pageNum'] = 1;
            if (Array.isArray(this.options[key])) {
                if (this.options[key].includes(value)) {
                    this.options[key] = this.options[key].filter(function(filterValue, index, arr){
                        return filterValue != value;
                    });
                } else {
                    this.options[key].push(value);
                }
            } else {
                this.options[key] = value;
            }

            this.reloadUrl();

            // this.reloadCategories();
            category.reloadCategory();
        },
        toggleAccordion(expandId, event) {
            var accordion = document.querySelector("#" + expandId);

            accordion.classList.toggle("max-h-0");
            accordion.classList.toggle("max-h-80");
            accordion.classList.toggle("overflow-hidden");
            accordion.classList.toggle("overflow-auto");
            event.target.closest(".accordion-header").querySelector(".icon-chevron-down").classList.toggle("rotate-180");
        },
    },
    mounted() {
        this.reloadCategories();
    }
});
const categoryFilters = categoryFiltersApp.mount('#categoryFilters');

const productSearchApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            options: productSearchOptions,
            productSearch: {},
            request: null,
            productSearchError: false,
            totalResults: 0
        }
    },
    methods: {
        callEndpoint() {
            var submission = new FormData();
            submission.append('action', 'productsfilter/products-filter/product-search');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);

            for (var key in this.options) {
                if (Array.isArray(this.options[key])) {
                    this.options[key].forEach(function(item, index) {
                        submission.append(key + "[]", item);
                    });
                } else if (this.options[key]) {
                    submission.append(key, this.options[key]);
                }
            }
            return submission;
        },
        reloadProductSearch() {
            var loading = true;
            this.options['pageNum'] = 1;
            if (document.querySelector("#productSearchQueryInput")) {
                this.options['search'] = document.querySelector("#productSearchQueryInput").value;
            }
            if (document.querySelector("#ficheSearch")) {
                this.options['search'] = document.querySelector("#ficheSearch").value;
            }
            this.productSearch = {};
            this.productSearchError = false;

            if (this.request) {
                this.request.cancel();
                this.request = null;
            }

            if (document.querySelector("#ficheSearch")) {
                if (!document.querySelector("#ficheSearch").value.length) {
                    return;
                }
            }

            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

            var submission = this.callEndpoint();
            axios.post('', submission, {cancelToken:axiosSource.token}).then(function (response) {
                this.request = null;
                var responseData = false;
                if (response.data.products) {
                    this.productSearch = response.data.products;
                    responseData = response.data;
                    this.productSearchError = false;
                } else if (response.products) {
                    this.productSearch = response.products;
                    responseData = response;
                    this.productSearchError = false;
                } else if (response.data.error) {
                    this.productSearch = {};
                    this.productSearchError = response.data.error;
                } else if (response.error) {
                    this.productSearch = {};
                    this.productSearchError = response.error;
                }
                loading = false;

                if (!this.productSearchError) {
                    this.totalResults = responseData.pagination.totalResults;
                    if (responseData.pagination.currentPage < responseData.pagination.totalPages) {
                        this.options['pageNum'] = responseData.pagination.currentPage + 1;
                        this.nextPage();
                    } else {
                        this.options['pageNum'] = 1;
                    }
                    if (responseData.pagination.currentPage == responseData.pagination.totalPages) {
                        this.productSearchError = "No more products";
                    }
                    if (responseData.pagination.totalResults == 0 || responseData.pagination.totalResults == '0') {
                        this.productSearchError = "Sorry, no matching products were found. Why not phone us to take advantage of our expert advice and product knowledge?";
                    }
                    if (lazyLoad) {
                        lazyLoad.getErrors('productSearch');
                    }
                } else {
                    this.totalResults = 0;
                }
            }.bind(this)).catch(function (error) {
                console.log(error);
                loading = false;
            });
        },
        cleanTitle(title, shortTitle) {
            if (title.includes(shortTitle)) {
                return title.replace(shortTitle, '');
            }
            return title;
        },
        nextPage() {
            if (this.options['pageNum'] == 1) {
                return false;
            }
            var loading = true;
            this.productSearchError = false;

            if (this.request) {
                this.request.cancel();
                this.request = null;
            }

            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

            var submission = this.callEndpoint();
            axios.post('', submission, { cancelToken:axiosSource.token }).then(function (response) {
                this.request = null;
                var responseData = false;
                if (response.data.products) {
                    responseData = response.data;
                    this.productSearchError = false;
                } else if (response.products) {
                    responseData = response;
                    this.productSearchError = false;
                } else if (response.data.error) {
                    this.productSearchError = response.data.error;
                } else if (response.error) {
                    this.productSearchError = response.error;
                }
                loading = false;
                if (!this.productSearchError) {
                    var fullProductSearch = this.productSearch;
                    responseData.products.forEach(function(item, index) {
                        fullProductSearch.push(item);
                    });
                    this.productSearch = fullProductSearch;
                    if (responseData.pagination.currentPage < responseData.pagination.totalPages) {
                        this.options['pageNum'] = responseData.pagination.currentPage + 1;
                        this.nextPage();
                    } else {
                        this.options['pageNum'] = 1;
                    }
                    if (responseData.pagination.currentPage == responseData.pagination.totalPages) {
                        this.productSearchError = "No more products";
                    }
                    if (responseData.pagination.totalResults == 0 || responseData.pagination.totalResults == '0') {
                        this.productSearchError = "Sorry, no matching products were found. Why not phone us to take advantage of our expert advice and product knowledge?";
                    }
                    if (lazyLoad) {
                        lazyLoad.getErrors('productSearch');
                    }
                }
            }.bind(this)).catch(function (error) {
                console.log(error);
                loading = false;
            });
        },
        fixDecimals(price) {
            price = price * 100;
            price = Math.round(price);
            price = price / 100;
            return price.toFixed(2);
        },
        removeHtmlTags(html) {
            var div = document.createElement("div");
            div.innerHTML = html;
            var strippedHtml = div.textContent || div.innerText || "";
            return strippedHtml;
        },
        addToBasket(event, purchasableId) {
            event.preventDefault();
            let button = event.target;
            var submission = new FormData();
            submission.append('action', 'commerce/cart/update-cart');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);
            submission.append('purchasableId', purchasableId);
            submission.append('qty', 1);
            if (this.request) {
                this.request.cancel();
                this.request = null;
            }
            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
            axios.post('', submission, { cancelToken:axiosSource.token }).then(function (response) {
                this.request = null;
                var responseData = false;
                this.cart = {};
                this.items = {};
                if (response.data.cart) {
                    responseData = response.data;
                    this.itemsError = false;
                } else if (response.cart) {
                    responseData = response;
                    this.itemsError = false;
                } else if (response.data.error) {
                    this.itemsError = response.data.error;
                } else if (response.error) {
                    this.itemsError = response.error;
                }
                if (!this.itemsError) {
                    this.cart = responseData.cart;
                    let basketTotal = this.cart.total - this.cart.totalShippingCost;
                    this.cart.basketTotal = this.fixDecimals(basketTotal);
                    this.items = responseData.cart.lineItems;

                    button.textContent = 'Added';
                    button.classList.add('brand-main-bg-colour');
                    button.classList.remove('bg-zinc-800');

                    document.querySelectorAll('.basketTotalQty').forEach(function(el) {
                      el.textContent = responseData.cart.totalQty;
                      el.closest('a').classList.add('brand-main-text-colour');
                      
                      var mobileBasketIcon = el.closest('#mobile-basket-icon');
                      
                      if (mobileBasketIcon) {
                        mobileBasketIcon.classList.remove('text-white');
                      }
                      
                      var desktopBasketIcon = el.closest('#desktop-basket-icon');
                      
                      if (desktopBasketIcon) {
                        desktopBasketIcon.classList.remove('text-banner-font');
                      }
                    });
                } else {
                    button.textContent = this.itemsError;
                    button.classList.add('brand-main-bg-colour');
                    button.classList.remove('bg-zinc-800');
                }
                setTimeout(function(){
                    // button.value = 'Add to basket';
                    button.classList.remove('brand-main-bg-colour');
                    button.classList.add('bg-zinc-800');

                    document.querySelectorAll('.basketTotalQty').forEach(function(el) {
                      el.closest('a').classList.remove('brand-main-text-colour');
                      
                      var mobileBasketIcon = el.closest('#mobile-basket-icon');
                      
                      if (mobileBasketIcon) {
                        mobileBasketIcon.classList.add('text-white');
                      }
                      
                      var desktopBasketIcon = el.closest('#desktop-basket-icon');
                      
                      if (desktopBasketIcon) {
                        desktopBasketIcon.classList.add('text-banner-font');
                      }
                    });
                }, 3000);

                let gaProduct = buildGaProduct(button.parentElement);
                dataLayerAddToCart(gaProduct);
            }.bind(this)).catch(function (error) {
                console.log(error);
            });
        }
    },
    mounted() {
        if (document.querySelector('#productSearchContainer')) {
            this.reloadProductSearch();
        }
    }
});
const productSearch = productSearchApp.mount('#productSearchContainer');

const productSearchFiltersApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            options: productSearchOptions,
        }
    },
    methods: {
        reloadUrl() {
            var url = document.querySelector('#productSearchContainer').dataset.pageurl+'?';
            for (var key in this.options) {
                if (key != 'pageNum') {
                    if (Array.isArray(this.options[key])) {
                        this.options[key].forEach(function(item, index) {
                            url += key + '[]=' + encodeURIComponent(item) + '&';
                        });
                    } else if (this.options[key]) {
                        url += key + '=' + encodeURIComponent(this.options[key]) + '&';
                    }
                }
            }
            window.history.replaceState({}, null, url.slice(0,-1));
        },
        clearOptions(key) {
            if (Array.isArray(this.options[key])) {
                this.options[key] = [];
            } else {
                this.options[key] = '';
            }
        },
        updateOptions(event, key, value) {
            this.options['pageNum'] = 1;
            if (Array.isArray(this.options[key])) {
                if (this.options[key].includes(value)) {
                    this.options[key] = this.options[key].filter(function(filterValue, index, arr){
                        return filterValue != value;
                    });
                } else {
                    this.options[key].push(value);
                }
            } else {
                this.options[key] = value;
            }

            this.reloadUrl();
            productSearch.reloadProductSearch();
        },
        toggleAccordion(expandId, event) {
            var accordion = document.querySelector("#" + expandId);

            accordion.classList.toggle("max-h-0");
            accordion.classList.toggle("max-h-80");
            accordion.classList.toggle("overflow-hidden");
            accordion.classList.toggle("overflow-auto");
            event.target.closest(".accordion-header").querySelector(".icon-chevron-down").classList.toggle("rotate-180");
        }
    },
    mounted() {
        const searchFilters = this;
        if (!document.querySelector('#ficheSearch')) {} else {
            return;
        }
        if (document.querySelector("#productSearchQueryInput")) {
            document.querySelector("#productSearchQueryInput").closest('form').addEventListener('submit', function(e) {
                e.preventDefault();
                searchFilters.updateOptions(e, 'search', document.querySelector("#productSearchQueryInput").value);
                return false;
            });
            document.querySelector("#productSearchQueryInput").addEventListener('change', function(e) {
                searchFilters.updateOptions(e, 'search', document.querySelector("#productSearchQueryInput").value);
            });
        }
    }
});
const productSearchFilters = productSearchFiltersApp.mount('#productSearchFilters');

const ficheFormApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            options: productSearchOptions,
        }
    },
    methods: {
        checkFiche(e) {
            productSearchFilters.updateOptions(e, 'search', document.querySelector("#ficheSearch").value);
        }
    }
});
const ficheForm = ficheFormApp.mount('#vueFicheForm');

const newsLoadApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data(){
        return {
            options: newsOptions,
            news: {},
            selectedNewsCategory: false,
            request: null,
            newsError: false
        }
    },
    methods: {
        callEndpoint() {
            var submission = new FormData();
            submission.append('action', 'productsfilter/products-filter/news');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);
            for (var key in this.options) {
              if (Array.isArray(this.options[key])) {
                this.options[key].forEach(function(item, index) {
                  submission.append(key + "[]", item);
                });
              } else if (this.options[key]) {
                submission.append(key, this.options[key]);
              }
            }
            return submission;
        },
        reloadNews() {
            var loading = true;
            this.options['pageNum'] = 1;
            this.options['sortBy'] = 'postDate desc';
            this.news = {};
            this.newsError = false;
        
            if (this.request) {
                this.request.cancel();
                this.request = null;
            }
        
            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
        
            var submission = this.callEndpoint();
            axios.post('', submission, { cancelToken:axiosSource.token }).then(function (response) {
                this.request = null;
                var responseData = false;
                if (response.data.news) {
                    this.news = response.data.news;
                    responseData = response.data;
                    this.newsError = false;
                } else if (response.news) {
                    this.news = response.news;
                    responseData = response;
                    this.newsError = false;
                } else if (response.data.error) {
                    this.news = {};
                    this.newsError = response.data.error;
                } else if (response.error) {
                    this.news = {};
                    this.newsError = response.error;
                }
                loading = false;
                if (!this.newsError) {
                    featuredNews.getFeaturedNews();
                    if (responseData.pagination.currentPage < responseData.pagination.totalPages) {
                        this.options['pageNum'] = responseData.pagination.currentPage + 1;
                        //this.nextPage();
                    } else {
                        this.options['pageNum'] = 1;
                    }
                    if (responseData.pagination.totalResults == 0 || responseData.pagination.totalResults == '0') {
                        this.newsError = "Sorry, no matching news articles were found. You can use our search to find what you're looking for.";
                    }
                    if (responseData.pagination.currentPage == responseData.pagination.totalPages) {
                        this.newsError = "No more results";
                    }
                    if (lazyLoad) {
                        lazyLoad.getErrors('news');
                    }
                }
            }.bind(this)).catch(function (error) {
                console.log(error);
                loading = false;
            });
        },
        nextPage() {
            if (this.options['pageNum'] == 1) {
                return false;
            }
            var loading = true;
            this.newsError = false;
            
            if (this.request) {
                this.request.cancel();
                this.request = null;
            }
            
            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
            
            var submission = this.callEndpoint();
            axios.post('', submission, { cancelToken:axiosSource.token }).then(function (response) {
                this.request = null;
                var responseData = false;
                if (response.data.news) {
                    responseData = response.data;
                    this.newsError = false;
                } else if (response.news) {
                    responseData = response;
                    this.newsError = false;
                } else if (response.data.error) {
                    this.newsError = response.data.error;
                } else if (response.error) {
                    this.newsError = response.error;
                }
                loading = false;
                if (!this.newsError) {
                    var fullNews = this.news;
                    responseData.news.forEach(function(news, index) {
                        fullNews.push(news);
                    });
                    this.news = fullNews;
                    if (responseData.pagination.currentPage < responseData.pagination.totalPages) {
                        this.options['pageNum'] = responseData.pagination.currentPage + 1;
                        //this.nextPage();
                    } else {
                        this.options['pageNum'] = 1;
                        this.newsError = "No more results";
                    }
                    if (responseData.pagination.totalResults == 0 || responseData.pagination.totalResults == '0') {
                        this.newsError = "Sorry, no matching news articles were found. You can use our search to find what you're looking for.";
                    }
                    if (responseData.pagination.currentPage == responseData.pagination.totalPages) {
                        this.newsError = "No more results";
                    }
                    if (lazyLoad) {
                        lazyLoad.getErrors('news');
                    }
                }
            }.bind(this)).catch(function (error) {
                console.log(error);
                loading = false;
            });
        },
        getFeaturedNews() {
            return this.news[Object.keys(this.news)[0]];
        },
        getnewsError() {
            return this.newsError;
        }
    },
    mounted() {
        this.reloadNews();
        
    }
});
const newsLoad = newsLoadApp.mount('#newsContainer');

const lazyLoadApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            errors: false
        }
    },
    methods: {
        lazyLoad(event, type) {
            event.preventDefault();
            if (type == "news") {
                newsLoad.nextPage();
            } else if (type == "products") {
                products.nextPage();
            }
            this.getErrors(type);
        },
        getErrors(type) {
            if (type == "news") {
                this.errors = newsLoad.getnewsError();
            } else if (type == "products") {
                this.errors = products.getProductsError();
            }
        }
    }
});
const lazyLoad = lazyLoadApp.mount('#lazyLoadContainer');

const featuredNewsApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            featuredNews: {}
        }
    },
    methods: {
      getFeaturedNews() {
          this.featuredNews = newsLoad.getFeaturedNews();
      }  
    },
    mounted() {
        this.getFeaturedNews();
        
    }
});
const featuredNews = featuredNewsApp.mount('#featuredNews');

const loader = new Loader({
  apiKey: "AIzaSyCFo9h__GpcAYojhNmoX-eiTTCf9MAJ49Q",
  version: "weekly",
  libraries: ["places"]
});
var mapOptions = {
  lat: 0,
  lng: 0,
  zoom: 5
}

if (document.querySelector("#defaultLat")) {
    mapOptions.lat = parseFloat(document.querySelector("#defaultLat").innerText);
}

if (document.querySelector("#defaultLng")) {
    mapOptions.lng = parseFloat(document.querySelector("#defaultLng").innerText);
}

if (document.querySelector("#defaultZoom")) {
    mapOptions.zoom = parseInt(document.querySelector("#defaultZoom").innerText);
}

const contactMapApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
          mapOptions: mapOptions,
          map: {}
        }
    },
    methods: {
        initMap() {
            loader.load()
            .then((google) => {
                this.map = new google.maps.Map(document.getElementById("contact-map-canvas"), { center: { lat: this.mapOptions.lat, lng: this.mapOptions.lng }, zoom: this.mapOptions.zoom });
                var markerLatLng = new google.maps.LatLng(this.mapOptions.lat, this.mapOptions.lng);
                var markerOptions = {
                  position: markerLatLng,
                  map: toRaw(this.map)
                };
                  
                var mapMarker = new google.maps.Marker(markerOptions);
            })
            .catch(e => {
                // do something
                alert("Something went wrong when loading the map");
                console.log(e);
            });
        },
    },
    mounted() {
      this.initMap();
    }
});
const contactMap = contactMapApp.mount('#contactMapContainer');

var purchasableId = 0;
var maxStock = 0;
var price = '£0.00';
var salePrice = '£0.00';
if (document.querySelector('input[name="purchasableId"]')) {
    var price = document.querySelector('input[name="purchasableId"]').dataset.price;
    var salePrice = document.querySelector('input[name="purchasableId"]').dataset.saleprice;
    document.querySelectorAll('input[name="purchasableId"]').forEach((input) => {
        if (purchasableId == 0 && input.dataset.stock > 0) {
            purchasableId = input.value;
            maxStock = input.dataset.stock;
            price = input.dataset.price;
            salePrice = input.dataset.saleprice;
        }
    });
}

const kitVariantSelector = 'input.kitVariant';
const selectedKitVariants = {};
if (document.querySelector(kitVariantSelector)) {
    document.querySelectorAll(kitVariantSelector).forEach((input) => {
        if (selectedKitVariants['p_' + input.dataset.productId] === undefined) {
            selectedKitVariants['p_' + input.dataset.productId] = {
                productId: input.dataset.productId,
                variantId: input.value,
                variantTitle: input.dataset.variantTitle,
                variantDescription: input.dataset.variantDescription,
                variantSku: input.dataset.variantSku,
            }
        }
    });
}

const addProductApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            selectedKitVariants: selectedKitVariants,
            purchasableId: purchasableId,
            maxStock: maxStock,
            price: price,
            salePrice: salePrice,
            qty: '',
            cart: {},
            items: {}
        }
    },
    // CRAFT_CSRF_TOKEN	"hD2vjOPelJ5Mn9ID3Y1DSihnZYtEasQxGP1N0rO9ra19iv30-Q5ka0IEqj8PnRDbOa7RPyNMZg-bFgOjB4tKm3h6PNlWF_AOF9KaX5n6aDeqE_ld7BfZ4OAwIwhm_8GEAyGDHLnnNrtDVNNItv-5ARiMFcIxhWejpNBlPKVdImTj-ocI9wy03lD31NpiBuKCKSLlLMFt4e6NvNbmAPSdeqXDcB5OHRDiByTzXmyVIo2A0eHyPPCshrVRBQ8-YMwMN6p0vl3KsAwRe1ZtrHc3wDK5e6JISwS7M3ORNy7qrmb8zFwAnCPPbtok7IbTCREwBc3z4GIYtiqJ0gPYJRGDBtSR20NgwH6NSP0pkPC2H0nMHmxTjI7vZ6g_2JIPtq6LEEq9401e1Bk="
    // action	"commerce/cart/update-cart"
    // redirect	"4a48b4dbea0cde532529a40b4ee7f78b460db6c20afc6d24e83afb62d3e64be7basket"
    // purchasableId	"28704"
    // qty	"1"
    methods: {
        fixDecimals(price) {
            price = price * 100;
            price = Math.round(price);
            price = price / 100;
            return price.toFixed(2);
        },
        updateKitVariant(productId, variantId, variantTitle, variantDescription, variantSku) {
            this.selectedKitVariants['p_' + productId] = {
                productId: productId,
                variantId: variantId,
                variantTitle: variantDescription,
                variantDescription: variantDescription,
                variantSku: variantSku,
            }
        },
        updatePurchasable(id, stock, price, salePrice) {
            this.purchasableId = id;
            if (stock > 8) {
                stock = 8;
            }
            this.maxStock = stock;
            this.price = price;
            this.salePrice = salePrice;
        },
        formSubmission(event) {
            event.preventDefault();
            var submission = new FormData();
            submission.append('action', 'commerce/cart/update-cart');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);
            submission.append('purchasableId', this.purchasableId);
            const options = []
            for (const [key, value] of Object.entries(this.selectedKitVariants)) {
                submission.append(`options[${value.productId}][productId]`, value.productId);
                submission.append(`options[${value.productId}][variantId]`, value.variantId);
                submission.append(`options[${value.productId}][variantTitle]`, value.variantTitle);
                submission.append(`options[${value.productId}][variantDescription]`, value.variantDescription);
                submission.append(`options[${value.productId}][variantSku]`, value.variantSku);
            }
            submission.append('qty', document.querySelector('select[name="qty"]').value);

            if (this.request) {
                this.request.cancel();
                this.request = null;
            }
            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

            axios.post('', submission, { cancelToken:axiosSource.token }).then(function (response) {
                this.request = null;
                var responseData = false;
                this.cart = {};
                this.items = {};
                if (response.data.cart) {
                    responseData = response.data;
                    this.itemsError = false;
                } else if (response.cart) {
                    responseData = response;
                    this.itemsError = false;
                } else if (response.data.error) {
                    this.itemsError = response.data.error;
                } else if (response.error) {
                    this.itemsError = response.error;
                }
                if (!this.itemsError) {
                    this.cart = responseData.cart;
                    let basketTotal = this.cart.total - this.cart.totalShippingCost;
                    this.cart.basketTotal = this.fixDecimals(basketTotal);
                    this.items = responseData.cart.lineItems;

                    document.querySelectorAll('.addToBasket').forEach((button) => {
                        button.value = 'Added';
                        button.classList.add('brand-main-bg-colour');
                        button.classList.remove('bg-zinc-800');
                    });
                    
                    document.querySelectorAll('.basketTotalQty').forEach(function(el) {
                      el.textContent = responseData.cart.totalQty;
                      el.closest('a').classList.add('brand-main-text-colour');
                      
                      var mobileBasketIcon = el.closest('#mobile-basket-icon');
                      
                      if (mobileBasketIcon) {
                        mobileBasketIcon.classList.remove('text-white');
                      }
                      
                      var desktopBasketIcon = el.closest('#desktop-basket-icon');
                      
                      if (desktopBasketIcon) {
                        desktopBasketIcon.classList.remove('text-banner-font');
                      }
                    });
                } else {
                    document.querySelectorAll('.addToBasket').forEach((button) => {
                        button.value = this.itemsError;
                        button.classList.add('brand-main-bg-colour');
                        button.classList.remove('bg-zinc-800');
                    });
                }
                setTimeout(function(){
                    document.querySelectorAll('.addToBasket').forEach((button) => {
                        // button.value = 'Add to basket';
                        button.classList.remove('brand-main-bg-colour');
                        button.classList.add('bg-zinc-800');
                    });
                    
                    document.querySelectorAll('.basketTotalQty').forEach(function(el) {
                      el.closest('a').classList.remove('brand-main-text-colour');
                      
                      var mobileBasketIcon = el.closest('#mobile-basket-icon');
                      
                      if (mobileBasketIcon) {
                        mobileBasketIcon.classList.add('text-white');
                      }
                      
                      var desktopBasketIcon = el.closest('#desktop-basket-icon');
                      
                      if (desktopBasketIcon) {
                        desktopBasketIcon.classList.add('text-banner-font');
                      }
                    });
                }, 3000);

                let gaProduct = buildGaProduct(document.querySelector('.addToBasket'));
                dataLayerAddToCart(gaProduct);
            }.bind(this)).catch(function (error) {
                console.log(error);
            });
        }
    },
    mounted() {
        const imageSwiper = new Swiper(".image-swiper", {
        modules: [Navigation],
        
        // Optional parameters
        slidesPerView: 2,
        centerInsufficientSlides: true,
        spaceBetween: 10,
        
        watchSlidesProgress: true,
        freeMode: true,
        
        // Responsive breakpoints
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 6,
          }
        }, 
          navigation: {
            nextEl: ".image-swiper-next",
            prevEl: ".image-swiper-prev",
        },
          
      });

        const mainImageSwiper = new Swiper(".main-image-swiper", {
            modules: [Navigation, Thumbs],
            spaceBetween: 10,
            thumbs: {
                swiper: imageSwiper,
            },
            navigation: {
                nextEl: ".main-image-button-next",
                prevEl: ".main-image-button-prev",
            },

        });

        function toggleImageModal(ev) {
            event = ev || window.event;
            if (event.target == ev.currentTarget) {

                var btnParent = ev.currentTarget.parentElement;
                let imageModal = document.querySelector("#image-modal");
                imageModal.classList.toggle("opacity-0");
                imageModal.classList.toggle("invisible");

                if (btnParent.hasAttribute("data-image-url")) {
                    imageModal.querySelector("img").src = btnParent.dataset.imageUrl;
                } else {
                    imageModal.querySelector("img").src = "";
                }
            }
        }

        document.querySelectorAll(".image-modal-btn").forEach(function(el) {
            el.addEventListener("click", toggleImageModal);
        });


    }
});
const addProduct = addProductApp.mount('#addProductContainer');

const sidebarApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            cart: {},
            items: {},
            freeShipping: false,
            amountLeft: 0,
            discountUpdate: false,
            discountError: false
        }
    },
    methods: {
        formSubmission(submission) {
            if (this.request) {
                this.request.cancel();
                this.request = null;
            }
            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
            axios.post('', submission, { cancelToken:axiosSource.token }).then(function (response) {
                this.request = null;
                var responseData = false;
                let oldCart = this.cart;
                this.cart = {};
                this.items = {};
                if (response.data.cart) {
                    responseData = response.data;
                    this.itemsError = false;
                } else if (response.cart) {
                    responseData = response;
                    this.itemsError = false;
                } else if (response.data.error) {
                    this.itemsError = response.data.error;
                } else if (response.error) {
                    this.itemsError = response.error;
                }
                if (!this.itemsError) {
                    this.cart = responseData.cart;
                    this.cart.itemSubtotal = this.fixDecimals(this.cart.itemSubtotal);
                    this.cart.totalDiscount = this.fixDecimals(Math.abs(this.cart.totalDiscount));
                    this.cart.total = this.fixDecimals(this.cart.total);
                    this.cart.totalTaxIncluded = this.fixDecimals(this.cart.totalTaxIncluded);
                    this.cart.totalShippingCost = this.fixDecimals(this.cart.totalShippingCost);
                    let basketTotal = this.cart.total - this.cart.totalShippingCost;
                    this.freeShipping = false;
                    // if (basketTotal >= 75 || this.cart.totalShippingCost == 0) {
                    if (basketTotal >= 75) {
                        this.freeShipping = true;
                        this.amountLeft = 0;
                    } else {
                        this.amountLeft = 75 - basketTotal;
                        this.amountLeft = this.fixDecimals(this.amountLeft);
                    }
                    this.cart.basketTotal = this.fixDecimals(basketTotal);
                    this.items = responseData.cart.lineItems;

                    let totalQty = responseData.cart.totalQty;
                    if (totalQty > 0) {} else {
                        totalQty = '';
                    }

                    document.querySelectorAll('.basketTotalQty').forEach(function(el) {
                        el.textContent = totalQty;
                        el.closest('a').classList.add('brand-main-text-colour');

                        var mobileBasketIcon = el.closest('#mobile-basket-icon');

                        if (mobileBasketIcon) {
                            mobileBasketIcon.classList.remove('text-white');
                        }

                        var desktopBasketIcon = el.closest('#desktop-basket-icon');

                        if (desktopBasketIcon) {
                            desktopBasketIcon.classList.remove('text-banner-font');
                        }
                    });
                }

                if (this.discountUpdate) {
                    this.discountUpdate = false;
                    this.discountError = 'Code ' + (responseData.cart.couponCode ?? '') +  ' successfully applied.';

                    const discountUnchanged = oldCart.totalDiscount == responseData.cart.totalDiscount;
                    const shippingUnchanged = oldCart.totalShippingCost == responseData.cart.totalShippingCost;
                    const totalUnchanged = oldCart.total == responseData.cart.total;

                    if (! responseData.cart.couponCode || responseData.cart.couponCode.toLowerCase() != document.querySelector('#discount-code').value.toLowerCase()) {
                        this.discountError = 'There was an error applying the discount, please check your code and try again.';
                    } else if (oldCart.couponCode == responseData.cart.couponCode) {
                        this.discountError = 'This code is already applied to your basket. Please ensure that you meet the criteria for the discount.';
                    } else if (!document.querySelector('#discount-code').value.length) {
                        this.discountError = 'Please enter a code to apply a discount.';
                    } else if (discountUnchanged && shippingUnchanged && totalUnchanged) {
                        // currently not actiones, the code may have been applied, but without affecting the total
                        // eg free shipping where shipping is already free
                        //this.discountError = 'There was an error applying the discount, please check your code and try again.';
                    }
                }

                let app = this;
                setTimeout(function(){
                    document.querySelectorAll('.basketTotalQty').forEach(function(el) {
                        el.closest('a').classList.remove('brand-main-text-colour');

                        var mobileBasketIcon = el.closest('#mobile-basket-icon');

                        if (mobileBasketIcon) {
                            mobileBasketIcon.classList.add('text-white');
                        }

                        var desktopBasketIcon = el.closest('#desktop-basket-icon');

                        if (desktopBasketIcon) {
                            desktopBasketIcon.classList.add('text-banner-font');
                        }
                    });
                    app.discountError = false;
                }, 3000);
            }.bind(this)).catch(function (error) {
                console.log(error);
            });
        },
        fixDecimals(price) {
            price = price * 100;
            price = Math.round(price);
            price = price / 100;
            return price.toFixed(2);
        },
        fetchItems() {
            var submission = new FormData();
            submission.append('action', 'commerce/cart/get-cart');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);
            this.formSubmission(submission);
        },
        updateDiscount(event) {
            this.discountUpdate = true;
            event.preventDefault();
            var submission = new FormData();
            submission.append('action', 'commerce/cart/update-cart');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);
            submission.append('couponCode', document.querySelector('#discount-code').value);
            this.formSubmission(submission);
        }
    },
    mounted() {
        this.fetchItems();
    }
});
const sidebar = sidebarApp.mount('#sidebarContainer');

const basketApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            cart: {},
            items: {},
            freeShipping: false,
            amountLeft: 0,
            discountUpdate: false,
            discountError: false,
            emailAddressValidation: true,
            emailAddressMessage: false
        }
    },
    methods: {
        formSubmission(submission) {
            if (this.request) {
                this.request.cancel();
                this.request = null;
            }
            const axiosSource = axios.CancelToken.source();
            this.request = { cancel: axiosSource.cancel, msg: "Loading..." };
            axios.post('', submission, { cancelToken:axiosSource.token }).then(function (response) {
                this.request = null;
                var responseData = false;
                let oldCart = this.cart;
                this.cart = {};
                this.items = {};
                if (response.data.cart) {
                    responseData = response.data;
                    this.itemsError = false;
                } else if (response.cart) {
                    responseData = response;
                    this.itemsError = false;
                } else if (response.data.error) {
                    this.itemsError = response.data.error;
                } else if (response.error) {
                    this.itemsError = response.error;
                }
                if (!this.itemsError) {
                    this.cart = responseData.cart;
                    this.cart.itemSubtotal = this.fixDecimals(this.cart.itemSubtotal);
                    this.cart.totalDiscount = this.fixDecimals(Math.abs(this.cart.totalDiscount));
                    this.cart.total = this.fixDecimals(this.cart.total);
                    this.cart.totalTaxIncluded = this.fixDecimals(this.cart.totalTaxIncluded);
                    this.cart.totalShippingCost = this.fixDecimals(this.cart.totalShippingCost);
                    let basketTotal = this.cart.total - this.cart.totalShippingCost;
                    this.freeShipping = false;
                    // if (basketTotal >= 75 || this.cart.totalShippingCost == 0) {
                    if (basketTotal >= 75) {
                        this.freeShipping = true;
                        this.amountLeft = 0;
                    } else {
                        this.amountLeft = 75 - basketTotal;
                        this.amountLeft = this.fixDecimals(this.amountLeft);
                    }
                    this.cart.basketTotal = this.fixDecimals(basketTotal);
                    this.items = responseData.cart.lineItems;

                    let totalQty = responseData.cart.totalQty;
                    if (totalQty > 0) {} else {
                        totalQty = '';
                    }
                    
                    document.querySelectorAll('.basketTotalQty').forEach(function(el) {
                      el.textContent = totalQty;
                      el.closest('a').classList.add('brand-main-text-colour');
                      
                      var mobileBasketIcon = el.closest('#mobile-basket-icon');
                      
                      if (mobileBasketIcon) {
                        mobileBasketIcon.classList.remove('text-white');
                      }
                      
                      var desktopBasketIcon = el.closest('#desktop-basket-icon');
                      
                      if (desktopBasketIcon) {
                        desktopBasketIcon.classList.remove('text-banner-font');
                      }
                    });
                }

                // I don't think we are doing discount updates in the basket.
                if (this.discountUpdate) {
                    this.discountUpdate = false;
                    this.discountError = 'Code ' + (responseData.cart.couponCode ?? '') +  ' successfully applied.';

                    const discountUnchanged = oldCart.totalDiscount == responseData.cart.totalDiscount;
                    const shippingUnchanged = oldCart.totalShippingCost == responseData.cart.totalShippingCost;
                    const totalUnchanged = oldCart.total == responseData.cart.total;

                    if (! responseData.cart.couponCode || responseData.cart.couponCode.toLowerCase() != document.querySelector('#discount-code').value.toLowerCase()) {
                        this.discountError = 'There was an error applying the discount, please check your code and try again.';
                    } else if (oldCart.couponCode == responseData.cart.couponCode) {
                        this.discountError = 'This code is already applied to your basket. Please ensure that you meet the criteria for the discount.';
                    } else if (!document.querySelector('#discount-code').value.length) {
                        this.discountError = 'Please enter a code to apply a discount.';
                    } else if (discountUnchanged && shippingUnchanged && totalUnchanged) {
                        // currently not actiones, the code may have been applied, but without affecting the total
                        // eg free shipping where shipping is already free
                        //this.discountError = 'There was an error applying the discount, please check your code and try again.';
                    }
                }

                let app = this;
                setTimeout(function(){
                    document.querySelectorAll('.basketTotalQty').forEach(function(el) {
                      el.closest('a').classList.remove('brand-main-text-colour');
                      
                      var mobileBasketIcon = el.closest('#mobile-basket-icon');
                      
                      if (mobileBasketIcon) {
                        mobileBasketIcon.classList.add('text-white');
                      }
                      
                      var desktopBasketIcon = el.closest('#desktop-basket-icon');
                      
                      if (desktopBasketIcon) {
                        desktopBasketIcon.classList.add('text-banner-font');
                      }
                    });
                    app.discountError = false;
                }, 3000);
            }.bind(this)).catch(function (error) {
                console.log(error);
            });
        },
        fixDecimals(price) {
            price = price * 100;
            price = Math.round(price);
            price = price / 100;
            return price.toFixed(2);
        },
        updateItems() {
            var submission = new FormData();
            submission.append('action', 'commerce/cart/update-cart');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);
            this.items.forEach(function(item, index) {
                submission.append('lineItems['+item.id+'][qty]', item.qty);
            });
            this.formSubmission(submission);
        },
        updateQuantity(event, lineId) {
            event.preventDefault();
            var items = this.items;
            items.forEach(function(item, index) {
                if (item.id == lineId) {
                    items[index].qty = event.target.value;
                }
            });
            this.items = items;
            this.updateItems();
        },
        removeItem(event, lineId) {
            event.preventDefault();
            var items = this.items;
            items.forEach(function(item, index) {
                if (item.id == lineId) {
                    items[index].qty = 0;
                }
            });
            document.querySelector('select[name="lineItems['+lineId+'][qty]"]').value = 0;
            document.querySelector('input[name="lineItems['+lineId+'][remove]"]').checked = 'checked';
            document.querySelector('#formLineItem'+lineId).style.display = 'none';
            document.querySelector('#hrLineItem'+lineId).style.display = 'none';
            this.items = items;
            this.updateItems();
        },
        fetchItems() {
            var submission = new FormData();
            submission.append('action', 'commerce/cart/get-cart');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);
            this.formSubmission(submission);
        },
        updateDiscount(event) {
            this.discountUpdate = true;
            event.preventDefault();
            var submission = new FormData();
            submission.append('action', 'commerce/cart/update-cart');
            submission.append('CRAFT_CSRF_TOKEN', document.querySelector('input[name="CRAFT_CSRF_TOKEN"]').value);
            submission.append('couponCode', document.querySelector('#discount-code').value);
            this.formSubmission(submission);
        },
        emailValidation() {
            let email = document.querySelector('#email').value;
            let regex = new RegExp("([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\"\(\[\]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\[[\t -Z^-~]*])");
            if (regex.test(email)) {
                this.emailAddressValidation = true;
                this.emailAddressMessage = false;
            } else {
                this.emailAddressValidation = false;
                this.emailAddressMessage = 'Please enter a valid email address';
            }
        },
        checkEmail(event) {
            this.emailValidation();
            if (!this.emailAddressValidation) {
                event.preventDefault();
                return false;
            }
        }
    },
    mounted() {
        this.fetchItems();
    }
});
const basket = basketApp.mount('#basketContainer');

let shippingPostcode = '';
let billingPostcode = '';
let showBilling = false;
if (document.querySelector('#shippingAddressPostcode')) {
    shippingPostcode = document.querySelector('#shippingAddressPostcode').value;
}
if (document.querySelector('#billingAddressPostcode')) {
    billingPostcode = document.querySelector('#billingAddressPostcode').value;
}
if (document.querySelector('#billingAddressSameAsShipping')) {
    showBilling = !document.querySelector('#billingAddressSameAsShipping').checked;
}

const addressApp = createApp({
    delimiters: ['{*', '*}'],
    // initial data
    data() {
        return {
            shippingAddressPostcode: shippingPostcode,
            billingAddressPostcode: billingPostcode,
            shippingAddressShow: false,
            billingAddressShow: false,
            showBilling: showBilling,
            emailAddressValidation: false,
            shippingAddressValidation: false,
            billingAddressValidation: false
        }
    },
    methods: {
        toggleFieldDisplay(event, model) {
            event.preventDefault();
            let name = model + 'Show';
            this[name] = !this[name];
        },
        toggleBillingDisplay(event) {
            this.showBilling = !this.showBilling;
            if (!this.showBilling) {
                this.billingAddressValidation = true;
            } else {
                this.$nextTick(() => {}).then(r => this.addressValidation('billingAddress'));
            }
        },
        updatePostcode(event, model) {
            let name = model + 'Postcode';
            this[name] = event.target.value;
        },
        searchPostcode(event, model) {
            event.preventDefault();
            let name = model + 'Postcode';
            let postcode = this[name];
            console.log(postcode);
            // add postcode lookup service here
        },
        postcodeLookupService(model) {
            PostcodeLookup.setup({
                // apiKey: "ak_lbxfiz3jU5XxAFQER30bNB2JIDdy9",
                apiKey: "ak_test",
                context: "#"+model+"-addressLookup-results",
                inputClass: "text-base bg-transparent focus:bg-white focus:placeholder-mid-grey sm:w-1/2 w-full border border-near-black placeholder-grey font-lato py-2 px-3  focus:border-brand-orange focus:outline-none focus:ring-1 focus:ring-brand-orange mb-4",
                buttonClass: "text-white uppercase bg-zinc-800 hover:bg-brand-orange hover:text-black border border-transparent py-2 px-4 sm:ml-2 sm:mb-0 mb-4",
                selectClass: "select address-country appearance-none bg-grey-100 block border border-grey-500 h-12 leading-tight px-4 rounded text-black w-full focus:outline-none focus:bg-yellow-100 focus:border-yellow-700 mb-4",
                hide: [
                    "#"+model+"-addressLookup-address"
                ],
                outputFields: {
                    line_1: "#"+model+"Address1",
                    line_2: "#"+model+"Address2",
                    post_town: "#"+model+"City",
                    county: "#"+model+"StateValue",
                    postcode: "#"+model+"ZipCode",
                }
            });

            let app = this;
            setTimeout(function(){
                if (app[model+'Validation']) {
                    if (document.querySelector('#' + model + '-addressLookup-results .idpc-unhide')) {
                        document.querySelector('#' + model + '-addressLookup-results .idpc-unhide').click();
                    }
                }
            }, 3000);


        },
        emailValidation() {
            let email = document.querySelector('#email').value;
            let regex = new RegExp("([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\"\(\[\]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\[[\t -Z^-~]*])");
            if (regex.test(email)) {
                this.emailAddressValidation = true;
            } else {
                this.emailAddressValidation = false;
            }
        },
        addressValidation(model) {
            let errors = 0;
            if (model === 'billingAddress' && !this.showBilling) {
                this.billingAddressValidation = true;
                return;
            }
            if (!document.querySelector('#'+model+'FirstName').value.length) {
                errors++;
            }
            if (!document.querySelector('#'+model+'LastName').value.length) {
                errors++;
            }
            if (!document.querySelector('#'+model+'Address1').value.length) {
                errors++;
            }
            if (!document.querySelector('#'+model+'City').value.length) {
                errors++;
            }
            if (!document.querySelector('#'+model+'StateValue').value.length) {
                errors++;
            }
            if (!document.querySelector('#'+model+'ZipCode').value.length) {
                errors++;
            }

            let name = model + 'Validation';
            if (errors > 0) {
                this[name] = false;
            } else {
                this[name] = true;
            }
            if (this.shippingAddressValidation && !this.showBilling) {
                this.billingAddressValidation = true;
            }
        }
    },
    mounted() {
        this.addressValidation('shippingAddress');
        this.addressValidation('billingAddress');
        this.postcodeLookupService('shippingAddress');
        this.postcodeLookupService('billingAddress');
        this.emailValidation();
    }
});
const address = addressApp.mount('#addressContainer');
